import type { ReactNode } from 'react';
import { DropdownSelector } from '#components/dropdown-selector/dropdown-selector';
import styles from './multi-select-filter.module.css';

export interface MultiSelectFilterProps {
  label: string;
  selectedValue: string;
  options: { value: string; label: string }[];
  onChange: (value: string) => void;
}

export function MultiSelectFilter({
  label,
  selectedValue,
  options,
  onChange,
}: MultiSelectFilterProps): ReactNode {
  return (
    <div className={styles.filter} data-testid="multi-select-filter">
      <span className={styles.label}>{label}</span>
      <DropdownSelector
        aria-label={label}
        buttonSize="sm"
        items={options.map(option => ({ key: option.value, label: option.label }))}
        onSelectionChange={onChange}
        selectedKey={selectedValue}
      />
    </div>
  );
}
